import React, { PureComponent, Fragment, createContext } from 'react';
import injectSheet from 'react-jss';
import { Row, Col, Card, Typography, Spin, Button } from 'antd';
const { Title, Text } = Typography;

import Chart from './Chart';
import AuthStorage from 'src/utils/AuthStorage';
import styles from './styles';
import CONSTANTS from 'src/constants';
import CompanyTable from 'src/containers/Dashboard/Company/Table';
const CompanyContext = createContext();

import { getDashboardCompany } from 'src/redux/actions/dashborad.js';

//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

function mapStateToProps(state) {
	return {
		store: {
			company: state.dashboard.company
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				// getListCreditDetails
				getDashboardCompany
			},
			dispatch
		)
	};
};

function numberWithSpaces(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class CompanyLayout extends PureComponent {
	state = {
		loading: true,
		companyData: [],
		selectedRows: [],
		selectedRowKeys: [],
	};

	filter = {
		limit: 12
	};

	componentDidMount() {
		const filter = this.filter;
		this.handelGetDashboardCompany(filter);
	}

	handelGetDashboardCompany = filter => {
		const { userId } = AuthStorage;
		const payload = {
			id: userId
			// params: filter
		};
		this.setState({ loading: true });
		this.props.action.getDashboardCompany(
			payload,
			() => {
				this.setState({ loading: false });
			},
			() => {
				this.setState({ loading: false });
			}
		);
	};

	setSelected = (selectedRows, selectedRowKeys) => {
		this.setState({ selectedRows, selectedRowKeys });
	};

	render() {
		const {
			classes,
			store: {
				company: { data = {} }
			}
		} = this.props;
		const { userId } = AuthStorage;
		const { loading } = this.state;
		const dataChart = data.credit_history || [];
		return (
			<div className="gutter-example" style={{ minWidth:1000 }}>
				<Row gutter={24} style={{ marginBottom: '15px' }}>
					<Col span={8}>
						<Spin spinning={loading}>
							<Card bordered={true}>
								<Title type="secondary" level={4}>
									Solde à affecter:
								</Title>
								<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
									{data.balance_info && numberWithSpaces(data.balance_info.company_current_balance) || '0'}{' '}
									<span style={{ fontSize: '11px' }}>{CONSTANTS.CURRENCY}</span>
								</Title>
							</Card>
						</Spin>
					</Col>
					<Col span={8}>
						<Spin spinning={loading}>
							<Card bordered={true}>
								<Title type="secondary" level={4}>
									Montant moyen par transaction:
								</Title>
								<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
									{data.average_amount_per_transaction && numberWithSpaces(parseInt(Math.round(data.average_amount_per_transaction))) || '0'}{' '}
									<span style={{ fontSize: '11px' }}>{CONSTANTS.CURRENCY}</span>
								</Title>
							</Card>
						</Spin>
					</Col>
					<Col span={8}>
						<Spin spinning={loading}>
							<Card bordered={true}>
								<Title type="secondary" level={4}>
									Total des crédits échangés ({moment(new Date).format('MM/YYYY')})
								</Title>
								<Title type="primary" style={{ color: '#00C68E', padding: 0, margin: 0 }}>
									{data.balance_info && numberWithSpaces(data.balance_info.total_balance_info) || '0'}{' '}
									<span style={{ fontSize: '11px' }}>{CONSTANTS.CURRENCY}</span>
								</Title>
							</Card>
						</Spin>
					</Col>
				</Row>
				<Row gutter={24} style={{ marginBottom: '15px' }}>
					<Col span={10}>

						{data.balance_info && data.balance_info.employee_total_balance != -1 && <Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={24}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Solde actuel des employés:
										</Title>
										<Title type="primary" style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.balance_info && numberWithSpaces(data.balance_info.employee_total_balance) || '0'}{' '}
											<span style={{ fontSize: '11px' }}>{CONSTANTS.CURRENCY}</span>
										</Title>
									</Card>
								</Spin>
							</Col>
						</Row>}
						<Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Moyenne quotidienne d'utilisation:
										</Title>
										<Title type="primary" style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.average_user_logged_app && numberWithSpaces(parseInt(Math.round(data.average_user_logged_app))) || '0'}{' '}
											<span style={{ fontSize: '11px' }}>/ jour</span>
										</Title>
									</Card>
								</Spin>
							</Col>

							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Moyenne quotidienne des transactions:
										</Title>
										<Title type="primary" style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.average_daily_amount_transaction && numberWithSpaces(parseInt(Math.round(data.average_daily_amount_transaction))) || '0'}{' '}
											<span style={{ fontSize: '11px' }}>/ jour</span>
										</Title>
									</Card>
								</Spin>
							</Col>
						</Row>
						<Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={24}>
								<Spin spinning={loading}>
									<Button
										style={{ backgroundColor: 'transaparent', color: '#00C68E' }}
										size="large"
										href={"/company-detail/" + userId}
									>
										Accéder à ma fiche d'adhésion
									</Button>
								</Spin>
							</Col>
						</Row>
					</Col>
					{data.balance_info && data.balance_info.employee_total_balance != -1 && <Col span={14}>
						<Spin spinning={loading}>
							<Card bordered={true}>
								<Title type="secondary" level={4}>
									Montants des 10 dernières transactions:
								</Title>
								<Title type="primary" style={{ color: '#00C68E', padding: 0, margin: 0 }}>
									<CompanyContext.Provider
										value={{
											data: data.transaction_info,
											selectedRowKeys: this.state.selectedRowKeys,
											self: this,

											setSelected: this.setSelected,
											getListCompany: this.getDashboardCompany,
											handleSearch: this.handleSearch,
										}}>
										<CompanyTable context={CompanyContext} />
									</CompanyContext.Provider>
								</Title>
							</Card>
						</Spin>
					</Col>}
				</Row>
				{/* <Row>
					<Col>
						<Spin spinning={loading}>
							<Chart data={dataChart} />
						</Spin>
					</Col>
				</Row> */}
			</div>
		);
	}
}
